import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal, Skeleton, notification } from 'antd'

import {
  RenewalEmployeeDTO,
  getAllEligibleEmployees,
  getQsehraAllEligibleEmployeesForRenewal,
  getRenewalClasses,
} from 'core/application/adminDashboard/benefitRenewal/confirmEmployeeClasses/confirmEmployeeClasses'
import { Product } from 'core/domain/product/Product'

import { useCommandRequest, useQueryRequest } from '../../../../common/hooks'
import EligibleEmployeesRenewalTable from './EligibleEmployeesRenewalTable'

type ConfirmEmployeeClassesModalProps = {
  productId: number
  onCancel?: () => void
  onConfirmEmployeeClasses?: () => void
  confirmEmployeeClassesHandler: (payload: RenewalEmployeeDTO[]) => Promise<any>
}

const ConfirmEmployeeClassesModal: React.FC<ConfirmEmployeeClassesModalProps> = (props) => {
  const { t: translate } = useTranslation()

  const [renewalClasses, isRenewalClassesLoading] = useQueryRequest(null, () => getRenewalClasses())
  const [eligibleEmployees, isEligibleEmployeesLoading] = useQueryRequest(null, () =>
    props.productId === Product.QsehraId ? getQsehraAllEligibleEmployeesForRenewal() : getAllEligibleEmployees(),
  )
  const [sendCommand, isCommandLoading] = useCommandRequest()

  const [submitList, setSubmitList] = useState<RenewalEmployeeDTO[]>([])

  const onSubmit = async () => {
    const request = submitList

    if (request.length === 0 && renewalClasses?.length === 1 && eligibleEmployees?.length > 0) {
      for (let i = 0; i < eligibleEmployees.length; i++) {
        request.push({ id: eligibleEmployees[i].employeeId, classId: renewalClasses[0].id })
      }
    }

    const result = await sendCommand(() => props.confirmEmployeeClassesHandler(request))

    if (result.completed) {
      notification.open({
        message: translate('admin-dashboard.home.confirm-renewal-classes.success'),
        type: 'success',
      })

      if (props.onConfirmEmployeeClasses) {
        props.onConfirmEmployeeClasses()
      }
    }
  }

  return (
    <Modal
      width="1000px"
      open={true}
      onCancel={props.onCancel}
      title={translate('admin-dashboard.home.confirm-renewal-classes.title')}
      footer={
        <div>
          <Button type="default" onClick={props.onCancel}>
            {translate('general.cancel')}
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            onClick={onSubmit}
            disabled={isCommandLoading}
            loading={isCommandLoading}
          >
            {translate('general.submit')}
          </Button>
        </div>
      }
    >
      <Skeleton loading={isRenewalClassesLoading || isEligibleEmployeesLoading}>
        {renewalClasses && eligibleEmployees && (
          <EligibleEmployeesRenewalTable
            renewalClasses={renewalClasses}
            employees={eligibleEmployees}
            translate={translate}
            submitList={submitList}
            onSelectedItemsChanged={(items) => setSubmitList(items)}
          />
        )}
      </Skeleton>
    </Modal>
  )
}

export default ConfirmEmployeeClassesModal
